import React from 'react'
import Profile from '../views/Profile'
import { useStore } from '../state/store'

export const ProfileContainer = () => {
  const workspaceId = useStore(state => state.workspace.id) as string
  const organizationId = useStore(state => state.organization.id) as string
  return <Profile workspaceId={workspaceId} organizationId={organizationId} />
}
